// Moved from `src/hooks/mutation/useMutateLogoutOrganizationMembers.ts` (now
// the app delegate) with the OT4 mutation slice (ARCFE-1033).
//
// Severed per ARCFE-921. Both toasts cross as ports. The success copy is
// pluralised on `input.user_ref_ids.length` and is deliberately UNIFIED with
// the "all matching" path (same message id) — the delegate keeps both the id
// and the count so that unification survives the move.
import { useMutation } from '@tanstack/react-query';

import { type LogoutMembersRequest } from '../../contracts';
import { logoutOrganizationMembersEverywhere } from '../api/organization';

export interface LogoutOrganizationMembersVariables {
  organizationId: string;
  input: LogoutMembersRequest;
}

export interface UseMutateLogoutOrganizationMembersOptions {
  /** App-reaction port: fired where the legacy success toast fired. */
  onLogoutStarted?: (memberCount: number) => void;
  /** App-reaction port: fired where the legacy destructive toast fired. */
  onLogoutError?: (error: unknown) => void;
}

/** POST /organization/{organization_id}/members/logout */
export function useMutateLogoutOrganizationMembers(
  options?: UseMutateLogoutOrganizationMembersOptions
) {
  return useMutation({
    mutationFn: async ({ organizationId, input }: LogoutOrganizationMembersVariables) => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }
      if (input.user_ref_ids.length === 0) {
        throw new Error('At least one member is required');
      }
      return await logoutOrganizationMembersEverywhere(organizationId, input);
    },
    onSuccess: (_data, { input }) => {
      options?.onLogoutStarted?.(input.user_ref_ids.length);
    },
    onError: (error) => {
      options?.onLogoutError?.(error);
    },
  });
}
